module.exports = __webpack_public_path__ + "media/alarmSound2.39d02b4d.mp3";